var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallCenter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "75 60 365 325",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4558_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_4618_",
    style: {
      fill: "#D8CECE"
    },
    cx: 268.408,
    cy: 217.392,
    r: 153.592
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4661_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4665_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M356.906,325.033c0.56-0.337,1.219-0.464,1.823-0.716 c2.558-1.071,3.648-4.283,3.182-7.017c-0.147-0.863-0.421-1.686-0.765-2.483c-3.661-2.351-5.871-5.384-5.871-8.697 c0-7.465,11.199-13.517,25.013-13.517c13.814,0,25.013,6.052,25.013,13.517s-11.199,13.517-25.013,13.517 c-2.08,0-4.098-0.14-6.03-0.398c-1.148,2.352-2.869,4.426-5.01,5.933c-3.258,2.294-7.421,3.264-11.358,2.644 c-0.761-0.12-1.648-0.419-1.839-1.165C355.889,326.016,356.346,325.37,356.906,325.033z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4664_",
    style: {
      fill: "#D8CECE"
    },
    d: "M393.801,302.488c-1.454,0.435-2.617,1.717-2.922,3.204 c-0.305,1.487,0.253,3.116,1.395,4.116c1.142,1,2.822,1.338,4.267,0.872c1.789-0.576,4.394-3.125,3.685-5.202 C399.447,303.202,395.975,301.838,393.801,302.488z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4663_",
    style: {
      fill: "#D8CECE"
    },
    d: "M376.366,308.102c-0.557-0.362-1.069-0.826-1.36-1.423 c-0.292-0.597-0.333-1.342,0.008-1.912c0.386-0.643,1.149-0.938,1.864-1.165c2.069-0.654,6.563-0.684,6.161,2.68 C382.665,309.421,378.38,309.41,376.366,308.102z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4662_",
    style: {
      fill: "#D8CECE"
    },
    d: "M364.549,303.369c-0.537-0.266-1.157-0.486-1.725-0.297 c-0.841,0.28-1.158,1.28-1.357,2.143c-0.14,0.606-0.28,1.22-0.261,1.842c0.077,2.513,3.505,3.188,5.162,1.667 C368.39,306.867,366.436,304.302,364.549,303.369z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4645_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_4629_",
    transform: "matrix(0.1566 -0.9877 0.9877 0.1566 -40.6126 272.6906)",
    style: {
      fill: "#D8CECE"
    },
    cx: 139.363,
    cy: 160.125,
    rx: 50.935,
    ry: 50.935
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_4631_",
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -130.4138 144.7154)",
    style: {
      fill: "#D8CECE"
    },
    cx: 109.48,
    cy: 229.781,
    rx: 31.48,
    ry: 31.48
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4579_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4557_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4560_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4617_",
    style: {
      fill: "#D54B31"
    },
    d: "M239.955,273.045c0-13.73,20.963-24.86,46.823-24.86 c25.86,0,46.823,11.13,46.823,24.86c0,8.507-8.053,16.012-20.327,20.494c-0.964,14.661-3.236,46.523-3.236,46.523 s-49.393,1.578-49.984,0c-0.539-1.441-4.071-41.579-4.684-48.582C245.903,286.932,239.955,280.358,239.955,273.045z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4515_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4581_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M241.35,292.522c-0.897,0-1.791-0.049-2.681-0.147 c-10.449-1.152-19.718-9.62-22.039-20.136l10.495-2.317c1.338,6.058,6.806,11.118,12.722,11.77 c6.854,0.736,13.375-3.781,17.186-8.279c4.894-5.777,7.879-13.316,10.765-20.607l9.992,3.957 c-3.056,7.721-6.521,16.473-12.557,23.598C258.672,288.107,249.911,292.522,241.35,292.522z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3967_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4580_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M325.247,332.736c-0.066-28.106-12.265-58.126-30.357-74.701l7.261-7.925 c20.171,18.479,33.772,51.673,33.844,82.599L325.247,332.736z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4507_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4616_",
    style: {
      fill: "#39405D"
    },
    d: "M228.481,182.478c0.294-3.852,1.83-7.783,4.911-10.114 c2.509-1.898,5.721-2.538,8.812-3.125c14.482-2.752,29.151-4.193,43.436-8.022c5.15-1.381,11.752-2.685,14.976-7.219 c2.666-3.75,3.644-8.967,6.754-12.872c4.056-5.092,9.622-9.015,15.866-10.91c5.962-1.809,12.886-1.701,17.915,1.977 c5.029,3.677,7.08,11.559,3.169,16.409c4.039,0.518,8.175,3.604,9.091,7.572c0.915,3.968-0.87,8.417-4.274,10.652 c0.371-0.064,0.742-0.129,1.113-0.193c2.005,0.221,2.756,2.85,2.507,4.851c-0.249,2.002-2.317,3.587-4.315,3.31 c6,0.409,11.848,5.596,12.717,11.547c0.869,5.951-2.858,12.258-8.491,14.367c3.701,1.502,5.715,6.516,4.894,10.425 c-0.702,3.344-3.443,5.624-6.558,6.666c2.47,4.892-7.94,6.405-10.861,4.864c0.431,3.467-1.548,7.102-4.694,8.622 c-3.145,1.52-7.223,0.812-9.672-1.68c-4.049,6.481-11.316,10.838-18.94,11.354c-1.311,0.089-4.7,3.572-6.118,4.309 c-2.407,1.252-4.993,2.158-7.649,2.71c-5.771,1.199-10.453,0.033-16.033-1.109c-11.608-2.376-22.438-4.94-31.078-13.876 c-9.931-10.272-13.264-25.054-16.188-39.039C228.982,190.172,228.187,186.329,228.481,182.478z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4537_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4615_",
    style: {
      fill: "#FABB8F"
    },
    d: "M271.238,249.029C271.527,248.959,271.05,249.259,271.238,249.029 L271.238,249.029z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4535_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4510_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4569_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M267.008,258.556c-0.151-1.857-0.278-3.76,0.226-5.553 c1.414-5.033,6.424-4.746,10.6-3.475c5.924,1.803,12.323,2.015,18.353,0.609c1.844-0.43,3.834-0.999,5.569-0.241 c1.755,0.766,2.729,2.741,2.867,4.651c0.118,1.631-0.261,3.244-0.694,4.83c-0.074,0.271-0.149,0.541-0.224,0.81 c-1.161,4.176-2.19,8.389-3.083,12.63c-1.848,8.767-2.708,17.598-3.89,26.445c-1.133,8.478,0.032,17.454,1.324,25.847 h-30.422c0.178-0.632,0.338-1.268,0.504-1.903c2.456-10.429,2.66-21.278,1.994-31.977 C269.451,280.309,267.894,269.461,267.008,258.556z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4566_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4568_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M269.027,258.113c0.472-0.899,0.906-2.023,1.301-3.257h3.046 c-2.301,7.945-4.212,17.325-1.188,19.407c5.453,3.756,29.832,4.252,26.539-4.554c-1.648-4.406-3.584-9.918-4.767-14.853h4.717 c0.355,1.903,0.793,3.727,1.326,5.136c1.938,5.117,19.453,13.714,5.68,22.468c-5.646,3.588-14.18,4.888-22.116,4.337 c-8.713-0.444-17.701-2.807-22.891-7.068C248.059,269.376,266.485,262.959,269.027,258.113z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4546_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4614_",
    style: {
      fill: "#E9EBF2"
    },
    d: "M282.57,257.811c0.291,1.25,1.896,1.113,2.201-0.036 c0.218-0.82-0.406-1.817-1.339-1.593C282.713,256.354,282.414,257.141,282.57,257.811z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4547_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4613_",
    style: {
      fill: "#E9EBF2"
    },
    d: "M282.503,267.215c0.291,1.25,1.896,1.113,2.201-0.036 c0.217-0.82-0.406-1.816-1.339-1.593C282.647,265.759,282.347,266.546,282.503,267.215z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4548_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4612_",
    style: {
      fill: "#E9EBF2"
    },
    d: "M282.876,279.307c0.291,1.25,1.896,1.113,2.201-0.036 c0.218-0.82-0.406-1.816-1.339-1.593C283.019,277.85,282.719,278.638,282.876,279.307z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4549_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4611_",
    style: {
      fill: "#E9EBF2"
    },
    d: "M282.876,293.47c0.291,1.25,1.896,1.113,2.201-0.036 c0.218-0.82-0.406-1.816-1.339-1.593C283.019,292.013,282.719,292.801,282.876,293.47z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4539_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4563_",
    style: {
      fill: "#E9EBF2"
    },
    d: "M265.2,261.829c-4.587,4.875-8.486,10.726-2.387,15.808 c10.748,8.061,25.527,9.405,37.619,2.687c7.874-3.374,5.388-11.456,1.216-17.94c4.652,5.181,15.844,12.57,4.033,20.077 c-5.646,3.588-14.179,4.888-22.116,4.337c-8.713-0.444-17.701-2.807-22.891-7.068 C251.028,271.813,259.526,266.2,265.2,261.829z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4514_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3622_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4521_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3628_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3630_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4534_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4610_",
    style: {
      fill: "#FABB8F"
    },
    d: "M283.995,254.916c0.037,0,3.251-2.131,3.275,0 c0.033,2.967,2.191-0.112,2.313-3.077l0.93-22.801c-2.807,0.033-5.614,0.065-8.421,0.098 c-4.776,0.056-3.071,8.076-3.168,11.467l-0.312,10.857C278.524,254.467,280.985,254.919,283.995,254.916z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4533_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4609_",
    style: {
      fill: "#FABB8F"
    },
    d: "M318.052,197.174c0.962-2.684,4.155-4.283,6.926-3.609 c2.77,0.675,4.838,3.415,4.904,6.266c0.066,2.851-1.762,5.607-4.34,6.826c-2.578,1.219-5.76,0.932-8.186-0.567"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3975_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4608_",
    style: {
      fill: "#FABB8F"
    },
    d: "M241.387,202.094c-0.839-2.725-3.957-4.467-6.755-3.918 c-2.798,0.549-4.987,3.193-5.182,6.038c-0.195,2.845,1.507,5.681,4.026,7.016c2.52,1.335,5.712,1.192,8.203-0.196"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3974_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4607_",
    style: {
      fill: "#FBA278"
    },
    d: "M236.147,202.411c1.208,11.072,5.598,22.228,14.153,29.361 c9.143,7.623,21.817,9.695,33.691,8.855c9.995-0.707,20.376-3.572,27.329-10.787c11.024-11.44,10.105-29.49,8.464-45.293 c-0.921-8.863-2.041-18.242-7.525-25.265c-5.738-7.349-15.254-10.714-24.485-12.037 c-9.159-1.313-18.715-0.939-27.362,2.356C237.856,158.196,233.787,180.774,236.147,202.411z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3973_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4606_",
    style: {
      fill: "#FABB8F"
    },
    d: "M244.534,212.865c-3.117-8.406-5.495-18.378-4.563-27.357 c11.265,1.977,22.771,3.413,34.124,2.024c6.05-0.741,12.032-2.332,17.55-4.943c3.689-1.745,11.894-5.657,13.051-9.9 c1.031,1.502,1.063,3.324,1.665,4.996c0.97,2.695,2.404,5.242,3.399,7.942c1.984,5.386,3.344,11.041,3.492,16.798 c0.242,9.412-3.122,19.269-10.457,25.171c-6.828,5.494-16.049,6.921-24.811,7.118c-6.02,0.136-12.228-0.257-17.674-2.826 c-6.821-3.217-11.753-9.58-14.759-16.496C245.188,214.56,244.85,213.717,244.534,212.865z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4511_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4567_",
    style: {
      fill: "#453248"
    },
    d: "M289.458,221.925c-0.695,0-1.405-0.074-2.114-0.224 c-0.362-0.077-0.594-0.434-0.517-0.797c0.077-0.363,0.443-0.59,0.798-0.518c2.275,0.487,4.562,0.058,6.106-1.146 c1.704-1.33,2.413-3.67,1.649-5.444c-0.147-0.34,0.01-0.736,0.35-0.882s0.737,0.009,0.883,0.351 c0.999,2.316,0.114,5.341-2.056,7.034C293.198,221.36,291.383,221.925,289.458,221.925z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4508_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4605_",
    style: {
      fill: "#39405D"
    },
    d: "M228.068,139.09c1.357-5.482,4.798-10.477,9.655-13.386 c-0.983-3.117,0.05-6.773,2.52-8.914c2.47-2.141,6.235-2.645,9.181-1.229c1.252-5.466,6.089-9.925,11.639-10.729 c5.55-0.804,11.453,2.099,14.205,6.985c0.485-2.462,2.712-4.475,5.212-4.709c2.499-0.234,5.061,1.331,5.994,3.661 c4.972-5.917,13.776-8.264,21.033-5.608c7.258,2.656,12.466,10.132,12.444,17.86c4.524-0.538,8.19,4.352,8.151,8.907 c-0.061,7.168-6.548,15.019-10.34,20.813c-4.507,6.887-10.193,12.944-16.105,18.636 c-10.202,9.823-25.447,12.041-39.608,12.265c-14.16,0.225-28.761-0.979-42.088,3.813 C216.992,170.82,219.487,152.85,228.068,139.09z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4522_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3627_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4604_",
    style: {
      fill: "#453248"
    },
    d: "M299.975,194.957c-0.732,0.19-1.372,0.654-1.875,1.22 c-1.11,1.25-1.574,3.082-1.059,4.672c0.516,1.59,2.052,2.833,3.723,2.871 C306.824,203.862,305.111,193.626,299.975,194.957z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4523_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4603_",
    style: {
      fill: "#453248"
    },
    d: "M248.965,200.793c-0.733,0.19-1.373,0.654-1.875,1.22 c-1.11,1.249-1.574,3.082-1.059,4.672c0.515,1.59,2.052,2.833,3.723,2.871C255.813,209.697,254.1,199.461,248.965,200.793 z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4520_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4602_",
    style: {
      fill: "#39405D"
    },
    d: "M333.95,136.639c-2.064-3.419-7.533-2.508-10.202,0.464 c-7.763,8.644-22.289,27.703-12.875,40.539c12.509,17.056,4.621,42.666,4.621,42.666s6.651-9.449,5.806-42.43l20.505,11.875 C341.805,189.752,342.359,150.569,333.95,136.639z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4512_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4565_",
    style: {
      fill: "#453248"
    },
    d: "M275.97,209.594c-0.325,0-0.66-0.063-0.995-0.189 c-0.922-0.348-1.672-1.125-1.956-2.028c-0.458-1.449,0.126-3.074,1.358-3.779c0.651-0.374,1.481-0.441,2.233-0.184 l-0.97-6.294c-0.057-0.367,0.195-0.71,0.561-0.766c0.361-0.051,0.71,0.195,0.766,0.562l1.252,8.122 c0.053,0.344-0.165,0.672-0.504,0.754c-0.345,0.087-0.684-0.106-0.795-0.435c-0.098-0.285-0.35-0.523-0.694-0.653 c-0.4-0.151-0.854-0.127-1.182,0.06c-0.673,0.386-1.008,1.377-0.745,2.209c0.161,0.512,0.613,0.973,1.149,1.176 c0.228,0.085,0.668,0.192,1.065-0.046c0.318-0.19,0.731-0.09,0.922,0.227c0.192,0.317,0.091,0.731-0.227,0.922 C276.833,209.479,276.411,209.594,275.97,209.594z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3629_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4601_",
    style: {
      fill: "#39405D"
    },
    d: "M296.592,184.91c-0.578-0.068-1.176-0.094-1.731,0.081 c-0.555,0.175-1.066,0.582-1.229,1.141c-0.183,0.626,0.106,1.316,0.571,1.774c0.465,0.458,1.079,0.728,1.685,0.969 c1.423,0.564,2.886,1.021,4.356,1.448c1.073,0.312,2.864,1.187,3.903,0.402c1.874-1.416-2.358-3.999-3.35-4.514 C299.488,185.531,298.057,185.083,296.592,184.91z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3972_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4600_",
    style: {
      fill: "#39405D"
    },
    d: "M250.593,187.966c0.578-0.068,1.176-0.094,1.731,0.081 c0.555,0.175,1.066,0.582,1.229,1.141c0.183,0.626-0.106,1.316-0.571,1.774c-0.464,0.458-1.079,0.728-1.685,0.969 c-1.423,0.564-2.886,1.021-4.356,1.448c-1.073,0.312-2.864,1.187-3.903,0.402c-1.874-1.416,2.357-3.999,3.35-4.514 C247.697,188.587,249.128,188.139,250.593,187.966z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_50_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4562_",
    style: {
      fill: "#E9EBF2"
    },
    d: "M293.619,250.077c-0.655,0.839-1.76,2.025-3.54,3.068 c-2.755,1.613-4.823,1.532-4.953,2.216c-0.33,1.741,12.693,6.042,14.577,3.722 C300.541,258.05,296.744,250.947,293.619,250.077z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_52_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4599_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M289.693,248.557c-0.329,0.89-0.959,2.18-2.256,3.46 c-2.006,1.982-3.931,2.284-3.829,2.935c0.262,1.659,13.612,3.238,14.59,0.766 C298.634,254.617,292.844,248.786,289.693,248.557z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4513_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4559_",
    style: {
      fill: "#E9EBF2"
    },
    d: "M274.61,249.658c0.655,0.839,1.76,2.025,3.54,3.068 c2.755,1.613,4.823,1.532,4.953,2.216c0.33,1.742-12.693,6.042-14.577,3.722C267.687,257.63,271.484,250.527,274.61,249.658z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4509_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4598_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M278.535,248.483c0.329,0.89,0.959,2.18,2.255,3.46 c2.006,1.982,3.932,2.284,3.829,2.935c-0.262,1.659-13.612,3.238-14.59,0.766 C269.595,254.543,275.384,248.712,278.535,248.483z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4540_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_4597_",
    style: {
      fill: "#F77738"
    },
    points: "184.44,370.104 361.285,370.104 352.387,329.243 193.985,329.303  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4517_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4596_",
    style: {
      fill: "#FABB8F"
    },
    d: "M323.341,326.636c-0.184,0.067-0.36,0.167-0.516,0.29 c-2.179,1.709-3.719,4.213-4.261,6.929c-0.229,1.148-0.284,2.372,0.54,3.41c0.105,0.132,0.25,0.251,0.398,0.334 c1.117,0.628,2.021,0.579,2.742,0.102c2.656,3.651,7.724,4.529,11.447,2.007c3.666-2.484,4.763-7.555,2.428-11.319 c-2.575-4.152-8.074-5.204-11.983-2.407C323.852,326.185,323.591,326.406,323.341,326.636z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4542_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4529_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4532_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4538_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4595_",
    style: {
      fill: "#39405D"
    },
    d: "M270.636,355.156h66.03c1.94,0,3.552-1.658,3.699-3.805l3.719-43.458 c0.163-2.387-1.536-4.424-3.693-4.428l-74.27-0.135c-2.275-0.004-4.017,2.244-3.673,4.739l4.521,43.592 C267.245,353.672,268.803,355.156,270.636,355.156z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4530_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4531_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4594_",
    style: {
      fill: "#58556A"
    },
    d: "M295.175,327.773c0,3.908,3.55,7.076,6.448,7.076 c2.898,0,7.83-3.168,7.83-7.076s-4.932-7.076-7.83-7.076C298.725,320.697,295.175,323.865,295.175,327.773z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4543_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4519_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4593_",
    style: {
      fill: "#36324B"
    },
    d: "M318.676,199.273c0,8.92-1.422,16.086,3.514,16.086 c4.936,0,11.263-7.231,11.263-16.151c0-8.92-6.326-16.152-11.263-16.152C317.254,183.056,318.676,190.352,318.676,199.273z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4524_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4592_",
    style: {
      fill: "#58556A"
    },
    d: "M324.267,198.11c0,4.692-0.748,8.461,1.849,8.461 c2.596,0,5.924-3.804,5.924-8.495c0-4.692-3.328-8.495-5.924-8.495C323.519,189.58,324.267,193.418,324.267,198.11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4525_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4545_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4591_",
    style: {
      fill: "#36324B"
    },
    d: "M269.283,132.398l-0.003,0.014c-2.592,0.112-5.298,0.324-8.137,0.655 C263.664,132.713,266.359,132.474,269.283,132.398z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4527_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4590_",
    style: {
      fill: "#36324B"
    },
    d: "M245.994,137.752c9.482-4.928,21.639-5.834,31.719-5.328 c18.394,0.924,35.348,9.229,42.61,26.873c2.27,5.516,3.52,11.443,3.925,17.385c0.058,0.853,0.86,7.655-0.081,8.175 c0,0-5.594,3.092-5.594,3.092c0.129-36.956-24.997-51.099-50.478-50.18c-14.44,0.521-34.378,4.927-39.676,32.445 c0.064-0.334,0.001-0.746,0.01-1.087c0.216-8.284,2.778-16.983,7.918-23.548 C238.958,142.245,242.27,139.688,245.994,137.752z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4526_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4561_",
    style: {
      fill: "#36324B"
    },
    d: "M294.106,230.919c-1.434,0-2.869-0.109-4.293-0.331l0.622-3.982 c7.088,1.104,14.541-1.056,19.939-5.777c5.398-4.723,8.528-11.823,8.375-18.994l4.031-0.087 c0.178,8.349-3.468,16.616-9.752,22.114C307.828,228.413,300.987,230.919,294.106,230.919z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4528_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4589_",
    style: {
      fill: "#36324B"
    },
    d: "M280.929,234.74h5.486c2.999,0,5.43-2.431,5.43-5.43l0,0 c0-2.999-2.431-5.43-5.43-5.43h-5.486c-2.999,0-5.43,2.431-5.43,5.43l0,0C275.499,232.309,277.93,234.74,280.929,234.74z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4555_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4554_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4588_",
    style: {
      fill: "#FABB8F"
    },
    d: "M215.88,266.193c-4.41,1.796-6.53,6.827-4.734,11.237 c1.796,4.411,6.827,6.53,11.237,4.734c4.41-1.796,6.53-6.827,4.734-11.237C225.321,266.516,220.29,264.397,215.88,266.193z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4553_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4587_",
    style: {
      fill: "#FABB8F"
    },
    d: "M229.58,271.422c0.585,0.476,0.857,1.259,0.851,2.013 c-0.006,0.754-0.26,1.484-0.575,2.169c-1.194,2.594-3.339,4.736-5.933,5.928c-0.286,0.131-0.604,0.254-0.908,0.17 C221.296,281.228,224.772,267.513,229.58,271.422z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4552_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4586_",
    style: {
      fill: "#453248"
    },
    d: "M218.73,246.208c0.959-0.637,2.18-1.192,3.382-1.273 c1.269-0.086,2.468,0.099,3.72,0.851l3.733,40.714l-4.26,10.361l-5.458-9.784L218.73,246.208z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4551_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_4585_",
    style: {
      fill: "#FABB8F"
    },
    points: "229.565,286.499 226.343,294.334 225.11,293.578 223.974,294.475  219.847,287.077 223.864,288.401 226.481,286.683 228.311,287.48  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4550_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4584_",
    style: {
      fill: "#FABB8F"
    },
    d: "M222.137,271.696c0.884,1.121,1.546,2.5,1.455,3.925 c-0.091,1.424-1.108,2.845-2.521,3.05c-1.281,0.187-2.489-0.604-3.474-1.443c-1.501-1.278-5.702-4.703-3.741-6.911 C216.275,267.593,220.271,269.33,222.137,271.696z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4518_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_4583_",
    style: {
      fill: "#FFFFFF"
    },
    points: "248.195,324.42 251.946,353.201 216.455,353.185 219.058,324.504  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4556_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_4582_",
    style: {
      fill: "#D54B31"
    },
    points: "361.285,370.104 358.98,376.669 186.002,375.662 184.44,370.104  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4619_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4624_",
    style: {
      fill: "#39405D"
    },
    d: "M181.411,160.187L181.411,160.187c0-3.426-2.777-6.204-6.204-6.204h-4.86 c-0.856-4.092-2.498-7.894-4.767-11.239l3.516-3.516c2.423-2.423,2.423-6.351,0-8.773l0,0c-2.423-2.423-6.351-2.423-8.773,0 l-3.587,3.587c-3.338-2.196-7.11-3.783-11.167-4.59v-5.109c0-3.426-2.777-6.204-6.204-6.204l0,0 c-3.426,0-6.204,2.778-6.204,6.204v5.109c-4.058,0.807-7.829,2.394-11.167,4.59l-3.587-3.587c-2.423-2.423-6.351-2.423-8.773,0 l0,0c-2.423,2.423-2.423,6.351,0,8.773l3.516,3.516c-2.269,3.345-3.911,7.147-4.767,11.239h-4.86 c-3.426,0-6.204,2.777-6.204,6.204l0,0c0,3.426,2.777,6.204,6.204,6.204h4.752c0.787,4.174,2.386,8.056,4.637,11.477 l-3.277,3.277c-2.423,2.423-2.423,6.351,0,8.773l0,0c2.423,2.423,6.351,2.423,8.773,0l3.206-3.206 c3.429,2.326,7.339,3.992,11.548,4.829v4.489c0,3.426,2.777,6.204,6.204,6.204l0,0c3.426,0,6.204-2.777,6.204-6.204v-4.489 c4.21-0.837,8.12-2.502,11.548-4.829l3.206,3.206c2.423,2.423,6.351,2.423,8.773,0l0,0c2.423-2.423,2.423-6.351,0-8.773 l-3.277-3.277c2.251-3.422,3.85-7.304,4.637-11.477h4.752C178.633,166.39,181.411,163.613,181.411,160.187z M142.697,179.903 c-13.47,2.21-24.951-9.271-22.741-22.74c1.338-8.157,7.917-14.736,16.074-16.074c13.47-2.209,24.95,9.27,22.741,22.74 C157.433,171.986,150.854,178.565,142.697,179.903z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4626_",
    style: {
      fill: "#39405D"
    },
    d: "M135.467,229.037L135.467,229.037c0-2.118-1.717-3.834-3.834-3.834h-3.004 c-0.529-2.529-1.544-4.879-2.947-6.946l2.173-2.173c1.497-1.497,1.497-3.925,0-5.422l0,0c-1.497-1.497-3.925-1.497-5.423,0 l-2.217,2.217c-2.063-1.357-4.394-2.338-6.902-2.837v-3.157c0-2.118-1.717-3.834-3.834-3.834h0 c-2.118,0-3.834,1.717-3.834,3.834v3.157c-2.508,0.499-4.839,1.479-6.902,2.837l-2.217-2.217c-1.497-1.497-3.925-1.497-5.423,0 l0,0c-1.497,1.497-1.497,3.925,0,5.422l2.173,2.173c-1.402,2.067-2.417,4.417-2.946,6.946h-3.004 c-2.118,0-3.834,1.717-3.834,3.834l0,0c0,2.118,1.717,3.834,3.834,3.834h2.937c0.486,2.579,1.474,4.979,2.866,7.093 l-2.026,2.026c-1.497,1.497-1.497,3.925,0,5.422l0,0c1.497,1.497,3.925,1.497,5.423,0l1.982-1.982 c2.119,1.438,4.536,2.467,7.137,2.984v2.774c0,2.118,1.717,3.834,3.834,3.834h0c2.118,0,3.834-1.717,3.834-3.834v-2.774 c2.602-0.517,5.018-1.547,7.137-2.984l1.982,1.982c1.497,1.497,3.925,1.497,5.423,0l0,0c1.497-1.497,1.497-3.925,0-5.422 l-2.026-2.026c1.392-2.115,2.38-4.514,2.866-7.093h2.937C133.751,232.872,135.467,231.155,135.467,229.037z M111.54,241.223 c-8.325,1.366-15.421-5.73-14.055-14.055c0.827-5.041,4.893-9.107,9.934-9.934c8.325-1.366,15.42,5.73,14.055,14.054 C120.648,236.33,116.582,240.396,111.54,241.223z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4621_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M216.447,241.016L216.447,241.016c0.823-3.326-1.207-6.689-4.533-7.512 l-4.718-1.167c0.152-4.178-0.53-8.263-1.929-12.055l4.257-2.569c2.934-1.77,3.877-5.583,2.107-8.517l0,0 c-1.77-2.934-5.583-3.877-8.517-2.107l-4.343,2.621c-2.713-2.934-5.993-5.38-9.739-7.137l1.227-4.959 c0.823-3.326-1.207-6.689-4.533-7.512l0,0c-3.326-0.823-6.689,1.207-7.512,4.533l-1.227,4.959 c-4.133-0.191-8.175,0.444-11.943,1.774l-2.621-4.344c-1.77-2.934-5.583-3.877-8.517-2.107l0,0 c-2.934,1.77-3.877,5.583-2.107,8.517l2.569,4.257c-3.006,2.702-5.513,5.999-7.327,9.765l-4.718-1.167 c-3.326-0.823-6.689,1.207-7.512,4.533l0,0c-0.823,3.326,1.207,6.689,4.533,7.512l4.613,1.141 c-0.238,4.24,0.382,8.393,1.746,12.255l-3.968,2.395c-2.934,1.77-3.877,5.583-2.107,8.517l0,0 c1.77,2.934,5.583,3.877,8.517,2.107l3.882-2.342c2.77,3.081,6.165,5.637,10.051,7.46l-1.078,4.358 c-0.823,3.326,1.207,6.689,4.533,7.512l0,0c3.326,0.823,6.689-1.207,7.512-4.533l1.078-4.358 c4.288,0.199,8.483-0.48,12.37-1.915l2.343,3.882c1.77,2.934,5.583,3.877,8.517,2.107l0,0c2.934-1.77,3.877-5.583,2.107-8.517 l-2.395-3.968c3.007-2.781,5.492-6.165,7.258-10.028l4.613,1.141C212.261,246.371,215.624,244.342,216.447,241.016z  M174.132,250.86c-13.607-1.089-21.995-14.99-16.615-27.536c3.257-7.597,11.223-12.403,19.463-11.744 c13.606,1.089,21.994,14.99,16.615,27.535C190.337,246.713,182.371,251.519,174.132,250.86z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4636_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M388.07,195.964c-7.324,0-13.261,5.937-13.261,13.261 c0,7.324,13.261,28.94,13.261,28.94s13.261-21.617,13.261-28.94C401.331,201.902,395.394,195.964,388.07,195.964z  M388.07,217.421c-4.526,0-8.196-3.669-8.196-8.196c0-4.526,3.669-8.196,8.196-8.196c4.527,0,8.196,3.669,8.196,8.196 C396.266,213.752,392.596,217.421,388.07,217.421z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4638_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M197.701,103.564c-7.324,0-13.261,5.937-13.261,13.261 s13.261,28.94,13.261,28.94s13.261-21.617,13.261-28.94S205.025,103.564,197.701,103.564z M197.701,125.02 c-4.526,0-8.196-3.669-8.196-8.196c0-4.526,3.669-8.196,8.196-8.196s8.196,3.669,8.196,8.196 C205.897,121.351,202.227,125.02,197.701,125.02z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4632_",
    style: {
      fill: "#39405D"
    },
    d: "M350.008,235.441c-4.526,0-8.196,3.669-8.196,8.196 c0,4.526,8.196,17.887,8.196,17.887s8.196-13.36,8.196-17.887C358.203,239.111,354.534,235.441,350.008,235.441z  M350.008,248.703c-2.797,0-5.065-2.268-5.065-5.065c0-2.798,2.268-5.065,5.065-5.065c2.798,0,5.065,2.268,5.065,5.065 C355.073,246.435,352.805,248.703,350.008,248.703z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4644_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4643_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M204.266,315.234c-0.56-0.337-1.219-0.464-1.823-0.716 c-2.558-1.071-3.648-4.283-3.182-7.017c0.147-0.863,0.421-1.686,0.765-2.484c3.661-2.351,5.87-5.384,5.87-8.697 c0-7.465-11.199-13.517-25.013-13.517s-25.013,6.052-25.013,13.517c0,7.465,11.199,13.517,25.013,13.517 c2.08,0,4.098-0.139,6.03-0.398c1.148,2.352,2.87,4.426,5.01,5.933c3.258,2.295,7.421,3.264,11.358,2.644 c0.761-0.12,1.648-0.419,1.839-1.165C205.283,316.218,204.826,315.571,204.266,315.234z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4630_",
    style: {
      fill: "#D8CECE"
    },
    d: "M167.371,292.69c1.454,0.435,2.617,1.717,2.922,3.204 c0.305,1.487-0.253,3.116-1.395,4.116c-1.142,1-2.822,1.338-4.267,0.872c-1.789-0.576-4.394-3.125-3.685-5.202 C161.725,293.403,165.197,292.04,167.371,292.69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4641_",
    style: {
      fill: "#D8CECE"
    },
    d: "M184.806,298.303c0.557-0.362,1.069-0.826,1.36-1.423 c0.292-0.597,0.333-1.342-0.008-1.912c-0.386-0.643-1.149-0.939-1.864-1.165c-2.069-0.654-6.563-0.684-6.161,2.68 C178.507,299.622,182.792,299.611,184.806,298.303z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4642_",
    style: {
      fill: "#D8CECE"
    },
    d: "M196.623,293.57c0.537-0.266,1.157-0.486,1.725-0.297 c0.841,0.28,1.158,1.28,1.357,2.143c0.14,0.606,0.28,1.22,0.261,1.841c-0.077,2.513-3.505,3.188-5.162,1.667 C192.782,297.069,194.736,294.503,196.623,293.57z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4646_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4650_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M356.392,289.295c0.346-0.208,0.754-0.287,1.126-0.443 c1.581-0.662,2.255-2.647,1.967-4.337c-0.091-0.533-0.26-1.042-0.473-1.535c-2.263-1.453-3.628-3.328-3.628-5.375 c0-4.614,6.921-8.354,15.46-8.354c8.538,0,15.46,3.74,15.46,8.354s-6.922,8.354-15.46,8.354c-1.285,0-2.533-0.086-3.727-0.246 c-0.709,1.453-1.773,2.735-3.096,3.667c-2.013,1.418-4.587,2.017-7.02,1.634c-0.47-0.074-1.018-0.259-1.137-0.72 C355.763,289.903,356.046,289.504,356.392,289.295z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4649_",
    style: {
      fill: "#D8CECE"
    },
    d: "M379.195,275.362c-0.899,0.269-1.617,1.061-1.806,1.98 c-0.189,0.919,0.156,1.926,0.862,2.544c0.706,0.618,1.744,0.827,2.637,0.539c1.106-0.356,2.716-1.932,2.277-3.215 C382.684,275.803,380.538,274.96,379.195,275.362z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4648_",
    style: {
      fill: "#D8CECE"
    },
    d: "M368.419,278.831c-0.344-0.223-0.661-0.511-0.841-0.88 c-0.18-0.369-0.206-0.829,0.005-1.182c0.238-0.397,0.71-0.58,1.152-0.72c1.279-0.404,4.056-0.422,3.808,1.656 C372.312,279.647,369.664,279.64,368.419,278.831z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4647_",
    style: {
      fill: "#D8CECE"
    },
    d: "M361.116,275.906c-0.332-0.164-0.715-0.301-1.066-0.183 c-0.52,0.173-0.716,0.791-0.839,1.324c-0.086,0.375-0.173,0.754-0.161,1.138c0.048,1.553,2.166,1.97,3.19,1.03 C363.49,278.068,362.282,276.483,361.116,275.906z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4651_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4655_",
    style: {
      fill: "#D8CECE"
    },
    d: "M117.004,378.467c0.651-0.392,1.418-0.539,2.119-0.833 c2.974-1.245,4.241-4.979,3.7-8.158c-0.171-1.003-0.49-1.96-0.89-2.887c-4.257-2.733-6.825-6.259-6.825-10.111 c0-8.679,13.019-15.714,29.079-15.714s29.079,7.035,29.079,15.714c0,8.679-13.019,15.714-29.079,15.714 c-2.418,0-4.764-0.162-7.01-0.463c-1.335,2.734-3.336,5.145-5.824,6.897c-3.787,2.667-8.628,3.794-13.204,3.074 c-0.885-0.139-1.916-0.487-2.138-1.355C115.822,379.611,116.353,378.859,117.004,378.467z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4654_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M159.896,352.259c-1.691,0.505-3.042,1.997-3.397,3.725 c-0.355,1.729,0.294,3.623,1.622,4.785c1.328,1.162,3.28,1.555,4.96,1.014c2.08-0.67,5.108-3.633,4.283-6.047 C166.459,353.088,162.423,351.503,159.896,352.259z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4653_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M139.627,358.785c-0.648-0.421-1.242-0.961-1.581-1.655s-0.388-1.56,0.01-2.223 c0.448-0.748,1.336-1.091,2.167-1.354c2.406-0.761,7.629-0.795,7.163,3.116C146.95,360.318,141.969,360.305,139.627,358.785z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4652_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M125.89,353.282c-0.624-0.309-1.345-0.565-2.006-0.345 c-0.977,0.326-1.346,1.488-1.577,2.491c-0.162,0.704-0.326,1.418-0.304,2.141c0.089,2.922,4.075,3.706,6.001,1.938 C130.355,357.349,128.083,354.367,125.89,353.282z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4656_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4660_",
    style: {
      fill: "#D8CECE"
    },
    d: "M100.384,336.129c0.419-0.252,0.912-0.347,1.363-0.536 c1.914-0.801,2.729-3.204,2.38-5.249c-0.11-0.646-0.315-1.261-0.572-1.858c-2.739-1.759-4.391-4.027-4.391-6.506 c0-5.584,8.377-10.111,18.711-10.111s18.711,4.527,18.711,10.111c0,5.584-8.377,10.111-18.711,10.111 c-1.556,0-3.066-0.104-4.511-0.298c-0.859,1.759-2.146,3.31-3.748,4.438c-2.437,1.716-5.551,2.441-8.496,1.978 c-0.569-0.09-1.232-0.313-1.376-0.872C99.623,336.865,99.965,336.381,100.384,336.129z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4659_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M127.982,319.265c-1.088,0.325-1.957,1.285-2.186,2.397 c-0.228,1.112,0.189,2.331,1.043,3.079c0.854,0.748,2.111,1.001,3.192,0.652c1.338-0.431,3.287-2.338,2.756-3.891 C132.205,319.798,129.608,318.779,127.982,319.265z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4658_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M114.94,323.464c-0.417-0.271-0.799-0.618-1.018-1.065 c-0.218-0.447-0.249-1.004,0.006-1.43c0.288-0.481,0.86-0.702,1.394-0.871c1.548-0.489,4.909-0.511,4.609,2.005 C119.652,324.451,116.447,324.442,114.94,323.464z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4657_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M106.101,319.923c-0.402-0.199-0.865-0.364-1.29-0.222 c-0.629,0.21-0.866,0.957-1.015,1.603c-0.104,0.453-0.21,0.913-0.195,1.378c0.058,1.88,2.622,2.384,3.861,1.247 C108.974,322.541,107.512,320.621,106.101,319.923z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallCenter);
export default __webpack_public_path__ + "static/media/callCenter.2dc064213ad2314979e22e57d3320ffd.svg";
export { ForwardRef as ReactComponent };